import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup, FormArray } from '@angular/forms';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { environment } from '../../../environments/environment';
import { NewChangePasswordComponent } from '../new-change-password/new-change-password.component';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { Location } from '@angular/common';

import { ActivatedRoute } from '@angular/router'; 

import Swal from 'sweetalert2';
import { CommonService } from 'src/app/shareModule/services/common.service';
@Component({
  selector: 'app-new-edit-profile',
  templateUrl: './new-edit-profile.component.html',
  styleUrls: ['./new-edit-profile.component.scss']
})
export class NewEditProfileComponent implements OnInit {
  edit_profile: FormGroup;
  submitted = false;
  profile_pic_url: any;
  profile_pic_path: any;
  selected_profile_pic: File;
  profile_pic_url_selected = 0;
  imgUrl = environment.ImageUrl
  user_image: any;
  user_email: any;
  company_name: any;
  user_id: any;
  user_card: any;
  public modalRef: any = null; 

  constructor(
    private fb: FormBuilder, 
    private route: ActivatedRoute,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private modalService: NgbModal,
    private customerService: CustomerService,
    private commonService: CommonService,
    private _location: Location
  ) { }

  ngOnInit(): void {

    this.edit_profile = this.fb.group({
      first_name: ["", [Validators.required]],
      last_name: ["", [Validators.required]],
      job_title: ["", [Validators.required]],
      phone_number: [""],
      whatsapp_number: ["", [Validators.required, Validators.minLength(7)]],
      // telegram_id: ["", [Validators.required]]
    });

    //let { id } = this.local.getUser;
    console.log(this.local.getUser());

    this.get_user_details_data();


    this.route.queryParams.subscribe(params => {
      const status = params['status'];
      console.log('Status:', status); // This will log 'complete' if the URL is `?status=complete`

      if (status === 'succeeded') {
        Swal.fire(
          'Added!',
          'Card added successfully',
          'success'
        );
      } else if (status === 'removed') {
        Swal.fire(
          'Removed!',
          'Card removed successfully',
          'success'
        );
      } else if (status) {
        Swal.fire(
          'Failed!',
          'Operation failed',
          'warning'
        );
      }
    });


  }

  get edit_profile_v() { return this.edit_profile.controls }

  get_user_details_data() {
    this.auth.get_user_details_data().subscribe((response: any) => {
      console.log(response.body);
      //user_card
      this.user_card = (response.body.auth_card=='')?'Add Card':'Update Card';  
      this.user_image = response.body.image;
      this.user_email = response.body.email;  
      this.company_name = response.body.user_detail.job_title;

      this.edit_profile = this.fb.group({
        first_name: [response.body.user_detail.first_name, [Validators.required]],
        last_name: [response.body.user_detail.last_name, [Validators.required]],
        job_title: [response.body.user_detail.job_title, [Validators.required]],
        phone_number: [response.body.user_detail.phone_number],
        whatsapp_number: [response.body.user_detail.w_phone_number, [Validators.required]],
        shop_description: [response.body.user_detail.shop_description, [Validators.required]],
        // telegram_id: [response.body.user_detail.telegram_user_id, [Validators.required]]
      });

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
    });
  }


  async removeCard(modal: any) { 
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'remove-card my-modal sm',
    });
  } 

  
  public async removecardconfirm() {
    this.customerService.removeCard({
      type: 'sub-admin',
    }).subscribe((resp: any) => {
      if (resp.message.trim() == "Card Removed.") {
        this.user_card = 'Add Card';
        this.toastr.success(resp.message);
        this.modalRef ? this.modalRef.close() : '';
      } else {
        this.toastr.error(resp.message);
      }
    },
      ({ error }) => {
        this.toastr.error(error.message);
      }
    );
  }



  async buyNow() {
    var productData = {
      userId: this.local.getUser().id,
    };
     
    Swal.fire({
      // title: 'Are you sure?',
      text: 'We will require you to add your credit card and will charge 1$ to verify.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Continue',
    }).then((result) => {
      if (result.isConfirmed) {
        var jsonproduct = JSON.stringify(productData); 
        let formData = new FormData();
        formData.append('id', this.local.getUser().id); //todo  
        formData.append('stripe_price_id', '1');
        formData.append('tokens', 'auth');
        formData.append('token', 'auth');
        formData.append('sub', jsonproduct);
        formData.append('notification_code', 'DEFAULT');
        formData.append('sub_type', '1');

        this.auth.create_stripe_checkout_url(formData).subscribe(
          (response: any) => {
            console.log(response.body);
            if (response.body.url != 'r')
              window.location.href = response.body.url;
            else if (response.body.message != '') {
              if (response.body.code == 0) {
                //this.subscribeto(token, 1, response.body.notification_code);
                return;
              }
            }
          },
          (e) => {
            if (e.status == 400) {
              this.toastr.error(e.error.message);
            }
          }
        );
      }
    });
    //if (!confirm('We will require you to add your crediit card for Rental')) {
    //   return;
    // }

    // Convert the JSON object to a JSON string
  }


  update_profile() {
    this.submitted = true;

    if(this.edit_profile.invalid) {
      return false;
    }

    let formData = new FormData();
    formData.append('first_name', this.edit_profile_v.first_name.value);
    formData.append('last_name', this.edit_profile_v.last_name.value);
    formData.append('job_title', this.edit_profile_v.job_title.value);
    // formData.append('country_code', '+65');
    formData.append('phone_number', this.edit_profile_v.phone_number.value);
    formData.append('w_country_code', '+65');
    formData.append('w_phone_number', this.edit_profile_v.whatsapp_number.value);
    formData.append('shop_description', this.edit_profile_v.shop_description.value);
    // formData.append('telegram_user_id', this.edit_profile_v.telegram_id.value);
    formData.append('image', this.selected_profile_pic);

    this.auth.update_user_details(formData).subscribe((response: any) => {
      this.get_user_details_data();
      this.toastr.success(response.message);
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
    });

  }

  onImageSelected(files, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.profile_pic_url = event.target.result;
        this.profile_pic_url_selected = 1;
      }
      reader.readAsDataURL(event.target.files[0]);
    }

    this.profile_pic_path = files;
    this.selected_profile_pic = <File>files[0];
  }

  change_password() {
    this.modalService.open(NewChangePasswordComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'v2_login_model' });
  }

  back() {
    this.commonService.goBack();
  }

}
